<template>
  <a-locale-provider :locale="locale">
    <div class="page-flight-search">
      <div class="mod-search">
        <div class="container">
          <l8-flightsearchbar :value="search" :hideMulti="mutipleEnbale" @search="onSearch">
          </l8-flightsearchbar>
        </div>
      </div>
      <div class="mod-content">
        <div class="container">
          <div v-if="showItinerary['normalFlight']" class="offers">
            <div v-if="!offers.length && loading" class="loading">
              <a-spin></a-spin>
            </div>
            <template
              v-else
              v-for="(offer, offerIndex) in offers"
            >
              <flight
                v-if="offer.type === 'Flight'"
                :ref="`flight-item-${offerIndex}`"
                :key="offer._uid"
                :criteria="search"
                :detail="offer.detail"
                :isJJC="isJJC"
                :offerIndex="offerIndex"
                :loading="offer.loading"
                :selectedProducts="selectedProducts"
                :ifInternational="ifInternational"
                :pageCmsData="pageCmsData"
                @search="onFlightSearch"
                @select="onFlightSelect"
                @cancelAll="onCancelAll"
              >
              </flight>
            </template>
            <div v-if="!loading && search.originDestinations && !offers.length" class="empty">
              抱歉，根据您的查询条件，暂无可预订的航班或者座位已售完，您可以选择其他日期进行查询或者购买其他航线机票。
            </div>
          </div>
          <div v-show="ifOnewayRecommendation && !allSelected" class="empty">
            尊敬的用户您好，您所查询的日期已售完或者当天无可用航班，我们为您推荐了临近日期其他出港城市的直飞航班。
          </div>
          <Approachs
            v-if="showItinerary['approachFlight'] && approachFlights.length"
            ref="approachs"
            :hasOffers="!!offers.length"
            :approachFlights="approachFlights"
            :approachDetail="approachDetail"
            :currentItineraryIndex="currentItineraryIndex"
            :selectedProducts="selectedProducts"
            :ifInternational="ifInternational"
            :isJJC="isJJC"
            :pageCmsData="pageCmsData"
            @select="onFlightSelect"
            @cancelAll="onCancelAll"
            @approachSearch="onApproachSearch"
          >
          </Approachs>
          <div class="mod-attention">
            <h4>注意事项</h4>
            <div>
              <p v-html="!ifInternational ? tipsContent : tipsContentInt"></p>
            </div>
          </div>
          <div class="mod-action flex-hr-vc" v-if="allSelected && offers?.length > 0">
            <div class="flex-hc-vl flex-v" v-if="ifInternational">
              <!-- 国际票展示税价 & 机票总价 -->
              <!-- 8L 国际票展示含税总价 -->
              <template v-if="airline === '8L'">
                <p class="total" >合计: {{ getTotalAmount(true) }}元</p>
                <p class="tax">全程含税总价</p>
              </template>
              <template v-else>
                <p class="total" >合计: {{ getTotalAmount(false) }}元</p>
                <p class="tax">全程税 {{ getTaxAmount() }}元</p>
              </template>
            </div>
            <a-button type="primary" size="large" @click="onSubmit" :loading="submitting">预订</a-button>
          </div>
        </div>
      </div>
      <!-- <form ref="passengerForm" action="/flight/passenger.html" method="post" target="_self">
        <input name="products" type="hidden" v-model="products" />
        <input name="_csrf" type="hidden" v-model="csrf">
      </form> -->
      <!-- <div class="mod-loading">
        <a-spin></a-spin>
      </div> -->
    </div>
  </a-locale-provider>
</template>

<script>
import { fetchPopupContent } from '@/apis/common'
import { fetchFlightSearch, fetchProductChoose } from '@/apis/flight'
import { getFlightSearchParams } from '@/assets/js/util'
import Observer from '@/assets/js/observer'
import Storage from '@/assets/js/storage'
import _ from 'lodash'
import moment from 'moment'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import Flight from './components/FlightCross'
import Approachs from './components/Approachs'
import { flightCities } from '@/assets/js/data'
import flightSearchPopupMixin from '@/mixin/flightSearchPopup'
import queryString from 'query-string'
import getAppInfo from '@/utils/from'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}
let uid = 1

export default {
  data () {
    return {
      search: {},
      offers: [],
      loading: false,
      submitting: false,
      locale: zhCN,
      selectedProducts: [],
      selectedProductsDetail: [],
      allSelected: false,
      products: '',
      isSaleInside: false,
      ifInternational: false,
      shoppingRespId: null,
      pageCmsData: null,
      tipsContent: '',
      tipsContentInt: '',
      mutipleEnbale: false,
      appInfo: getAppInfo(),
      track: {
        startPostTime: null,
        endPostTime: null,
        startRenderTime: null,
        endRenderTime: null
      },
      airline: mainSettings?.airline,
      adultWithChildTipsCount: 1,
      ifOnewayRecommendation: false,
      approachFlights: [],
      approachDetail: {},
      showItinerary: {
        normalFlight: true,
        approachFlight: true
      },
      approachSwitch: false,
      currentItineraryIndex: -1,
      enableUploadJjcCert: false
    }
  },
  provide () {
    return {
      ifInternational: () => this.ifInternational,
      isRoundTrip: () => this.search?.tripType === 'ROUNDTRIP'
    }
  },
  mixins: [flightSearchPopupMixin],
  computed: {
    isJJC () {
      const { passenger } = this.search

      if (passenger && (passenger.PWD || passenger.MWD)) {
        return true
      }

      return false
    },
    passengerStr () {
      const passenger = Object.assign({}, this.search.passenger)
      const list = []

      if (passenger.ADT) {
        list.push(`ADT|${passenger.ADT}`)
      }

      if (passenger.MWD || passenger.PWD) {
        list.push('ADT|1')
      }

      list.push(`CHD|${passenger.CNN || 0}`)
      list.push(`INF|${passenger.INF || 0}`)

      return list.join('#')
    }
  },
  created () {
    const params = queryString.parse(location.search)
    let data = {
      tripType: params.type || 'ONEWAY',
      isInternational: params.isInternational === 'true'
    }
    // this.ifInternational = params.isInternational
    const passenger = { ADT: 0, CNN: 0, INF: 0, MWD: 0, PWD: 0 }
    const keys = Object.keys(passenger)
    // 用于判断 params 是否携带旅客人数
    let flag = false

    for (const key of keys) {
      if (params[key] && parseInt(params[key]) > 0) {
        passenger[key] = parseInt(params[key])
        flag = true
      }
    }

    data.passenger = flag ? passenger : { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 }

    if (params.depCode && params.arrCode) {
      const originDestinations = [
        {
          depCode: params.depCode,
          depType: params.depType || 'city',
          arrCode: params.arrCode,
          arrType: params.arrType || 'city',
          flightDate: params.depDate || moment().format('YYYY-MM-DD')
        }
      ]

      if (params.arrDate) {
        originDestinations.push({
          depCode: params.arrCode,
          depType: params.arrType || 'city',
          arrCode: params.depCode,
          arrType: params.depType || 'city',
          flightDate: params.arrDate
        })
      }

      data.originDestinations = originDestinations
    }

    // MOCK: 临时处理

    // 往返
    // data = {
    //   tripType: 'ROUNDTRIP',
    //   isInternational: true,
    //   originDestinations: [
    //     {
    //       depCode: 'URC',
    //       arrCode: 'HKG',
    //       flightDate: '2023-03-15',
    //       arrType: 'airport',
    //       depType: 'airport'
    //     },
    //     {
    //       depCode: 'HKG',
    //       arrCode: 'URC',
    //       flightDate: '2023-03-22',
    //       arrType: 'airport',
    //       depType: 'airport'
    //     }
    //   ],
    //   passenger: { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 }
    // }

    // 中转
    // data = {
    //  isInternational: true,
    //   tripType: 'ONEWAY',
    //   originDestinations: [
    //     {
    //       depCode: 'HAK',
    //       arrCode: 'BKK',
    //       flightDate: '2023-03-11',
    //       arrType: 'airport',
    //       depType: 'airport'
    //     }
    //   ],
    //   passenger: { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 }
    // }

    // 单程
    // data = {
    //   isInternational: true,
    //   tripType: 'ONEWAY',
    //   originDestinations: [
    //     {
    //       depCode: 'URC',
    //       arrCode: 'HKG',
    //       flightDate: '2023-03-22',
    //       arrType: 'airport',
    //       depType: 'airport'
    //     }
    //   ],
    //   passenger: { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 }
    // }

    this.search = data
    if (data.originDestinations && data.originDestinations.length) {
      this.track.startRenderTime = moment(new Date()).valueOf()
      this.onSearch(data)
    }

    this.$watch('selectedProducts', selectedProducts => {
      if (!selectedProducts.length) {
        this.allSelected = false
        this.products = ''
      }

      let flag = true

      for (let i = 0, len = selectedProducts.length; i < len; i++) {
        if (!selectedProducts[i]) {
          flag = false
          break
        }
      }
      this.products = JSON.stringify(selectedProducts)
      this.allSelected = flag
    }, {
      deep: true
    })
    window.__MICRO_ROOT__?.api?.track?.('reserve_OTA_view')
  },
  async mounted () {
    this.pageCmsData = (await mainSettings.cms?.getPageData()) ?? {}
    this.tipsContent = _.get(this.pageCmsData, 'search-tips.content')
    this.tipsContentInt = _.get(this.pageCmsData, 'search-tips-int.content')
    this.mutipleEnbale = _.get(this.pageCmsData, 'config.mutipleEnbale')
    this.enableUploadJjcCert = _.get(this.pageCmsData, 'jjc-cert-upload-config.enableUploadJjcCert') || false
  },
  methods: {
    async onSearch (data) {
      const cmsData = (await mainSettings.cms?.getPageData()) ?? {}
      this.approachSwitch = _.get(cmsData, 'approach-switch')?.enable || false
      this.search = Object.assign({}, data)
      this.getAllPopup(data)
      this.handleFlightSearchInit()
      this.handleFlightSearchValidateBefore(data)
    },
    getAllPopup (searchParams, type = 'FlightSearch', channel = 'pc') {
      const params = { type, channel, ...searchParams }
      fetchPopupContent(params)
        .then(data => {
          this.doSearchCond(data)
        })
        .catch(err => {
          this.$message.error(err.message || '网络异常，请稍后再试！')
        })
    },
    handleFlightSearchInit () {
      this.ifOnewayRecommendation = false
      this.offers = []
    },
    // 航班查询-请求前校验
    handleFlightSearchValidateBefore (data, index) {
      const observer = new Observer()
      if (['JD', 'Y8'].includes(mainSettings.airline)) {
        const query = getFlightSearchParams(this.search)
        const keys = Object.keys(query)
        if ((keys?.includes('CNN') || keys?.includes('INF')) && this.adultWithChildTipsCount === 1) {
          this.adultWithChildTipsCount++
          observer.add(() => {
            return new Promise((resolve, reject) => {
              const { name, hotline } = this.appInfo
              const message = `预订${name}实际承运的国内、国际航班时，每名年满18周岁的成人最多可带3名未满5岁的儿童，含1名婴儿；携带5（含）至12岁（不含）以下儿童无数量限制。如同行的儿童为残疾儿童，则仅可携带一名残疾儿童出行，不能再携带其他儿童及婴儿同行，详情可联系${hotline}咨询。预订非${name}实际承运的国内、国际及联程段航班，每名年满18周岁的成人最多可携带2名儿童及1名婴儿。`
              this.$info({
                title: '温馨提示',
                content: message,
                okText: '知道了',
                onOk: () => {
                  resolve()
                }
              })
            })
          })
        }
      }
      observer.complete = () => {
        this.handleFlightSearchFetch(data, index)
      }
      if (observer.queue.length) {
        observer.start()
      } else {
        this.handleFlightSearchFetch(data, index)
      }
    },
    // 航班查询-发起请求
    handleFlightSearchFetch (data, index, approachSearchType) {
      if (!approachSearchType) {
        this.loading = true

        if (typeof index === 'number') {
          this.offers.splice(index, 1, {
            ...this.offers[index],
            loading: true
          })
        }
      }

      const { originDestinations, passenger, isInternational, tripType } = data

      if (!originDestinations || !passenger) {
        this.$message.error('未知的行程信息，请重新搜索！')
        return false
      }

      // if (['JD', 'Y8'].includes(mainSettings.airline)) {
      //   const { appInfo } = this
      //   for (let key in passenger) {
      //     if ((key === 'CNN' || key === 'INF') && passenger[key] > 0 && this.adultWithChildTipsCount === 1) {
      //       this.adultWithChildTipsCount++
      //       this.$message.warn(`预订${appInfo.name}实际承运的国内、国际航班时，每名年满18周岁的成人最多可带3名未满5岁的儿童，含1名婴儿；携带5（含）至12岁（不含）以下儿童无数量限制。如同行的儿童为残疾儿童，则仅可携带一名残疾儿童出行，不能再携带其他儿童及婴儿同行，详情可联系${appInfo.hotline}咨询。预订非${appInfo.name}实际承运的国内航班，每名年满18周岁的成人最多可携带2名儿童及1名婴儿。`)
      //       break
      //     }
      //   }
      // }

      const passengers = []
      let isJJC = ''

      for (let key in passenger) {
        if (passenger[key] > 0) {
          if (key === 'MWD' || key === 'PWD') {
            isJJC = key
          }

          passengers.push({
            passengerType: key,
            passengerNum: passenger[key]
          })
        }
      }

      if (isJJC) {
        if (!mainSettings.user?.hasLogin()) {
          this.$error({
            content: '请先登录！',
            onOk: () => {
              window.__MICRO_ROOT__.eventBus.emit('user.expired', null, {
                isModal: true
              })
            }
          })
        }
        Storage.setItem('isJJC', isJJC, 0.5 * 3600000)
      } else {
        Storage.removeItem('isJJC')
      }

      originDestinations.forEach(item => {
        item.flightDate = moment(item.flightDate).format('YYYYMMDD')
      })

      let isSearchApproach = this.approachSwitch && !isInternational && this.search?.tripType === 'ONEWAY' && !approachSearchType
      const params = {
        originDestinations,
        passengers,
        tripType: ['MULTIWAY', 'LC'].includes(tripType) ? 'ONEWAY' : tripType,
        ifInternational: isInternational,
        alineCode: mainSettings.airline,
        approach: isSearchApproach
      }

      this.track.startPostTime = moment(new Date()).valueOf()
      this.ifInternational = isInternational
      fetchFlightSearch(params)
        .then(res => {
          if (!approachSearchType) {
            this.loading = false
            this.handleFlightSearchValidateAfter(res, index)
          } else {
            this.approachDetail = res.offers?.[0]?.detail || {}
            if (_.isEmpty(this.approachDetail)) {
              this.$message.error('暂无数据，请稍后重试')
            }
            this.currentItineraryIndex = _.findIndex(this.$refs.approachs.$refs.approachItinerary, (aItem) => {
              return aItem.itinerary.orgDsts[0].flightNo === originDestinations[0].flightNo
            })
            this.$nextTick(() => {
              this.$refs.approachs.$refs.approachItinerary[this.currentItineraryIndex]?.handleCabinBrands(true, false)
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message || '网络异常，请稍后再试！')
          this.track.endPostTime = moment(new Date()).valueOf()
          this.handleUniTrack(err)
        })
    },

    // 航班查询-请求后校验
    handleFlightSearchValidateAfter (res, index) {
      const observer = new Observer()
      const query = getFlightSearchParams(this.search)
      if (['JD'].includes(mainSettings.airline)) {
        // JD - 军警残优化支持低价提示
        const { offers = [], criteria = {} } = res
        const jjcNoteFlag = offers.find(item => item.jjcNote) ?? false
        if (jjcNoteFlag) {
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                content: '更多优惠价格可选择，可返回普通旅客购票页面进行购票。(退改签按照所选产品规则执行)',
                okText: '需要',
                cancelText: '不需要',
                onOk: () => {
                  query.ADT = 1
                  delete query.MWD
                  delete query.PWD
                  window.__MICRO_ROOT__.router?.push({ pathname: '/micro/main/flight/search', query })
                },
                onCancel: () => {
                  resolve()
                }
              })
            })
          })
        }
        // JD - 直飞航线推荐（单程）
        const { originDestinations = [], recommendations = [] } = criteria
        const { itinerarys = [] } = offers?.[0]?.detail
        if (itinerarys?.length === 0 && originDestinations?.length === 1 && recommendations?.length > 0) {
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                content: '未查询到相应的航班数据，为您推荐临近日期其他城市出港的直飞航线',
                okText: '需要',
                cancelText: '不需要',
                onOk: () => {
                  const recommendation = criteria.recommendations[0]
                  this.search.originDestinations.splice(0, 1, recommendation)
                  this.ifOnewayRecommendation = true
                  this.handleFlightSearchValidateBefore(this.search)
                },
                onCancel: () => {
                  resolve()
                }
              })
            })
          })
        }
      }
      if (observer.queue.length) {
        observer.start()
      } else {
        this.handleFlightSearchResponse(res, index)
      }
      observer.complete = () => {
        this.handleFlightSearchResponse(res, index)
      }
    },

    // 航班查询-响应处理
    handleFlightSearchResponse (data, index) {
      this.track.endPostTime = moment(new Date()).valueOf()
      if (typeof index === 'number') {
        // TODO: 保留原有逻辑，机+X的单段查询会有问题
        if (data.offers[0]) {
          const offer = data.offers[0]
          offer._uid = uid++
          offer.loading = false
          this.offers.splice(index, 1, offer)
        } else {
          this.offers = []
        }
      } else {
        const list = []
        const listDetail = []
        this.offers = data.offers.map(offer => {
          list.push(null)
          listDetail.push(null)

          return {
            ...offer,
            loading: false,
            _uid: uid++
          }
        })
        this.selectedProducts = list
        this.selectedProductsDetail = listDetail
      }
      if (data.offers?.[0]?.shoppingRespId) {
        this.ifInternational = data.offers?.[0].ifInternational
        this.shoppingRespId = data.offers?.[0].shoppingRespId
      }
      this.approachFlights = data.approachs || []
      this.$nextTick(() => {
        this.track.endRenderTime = moment(new Date()).valueOf()
        this.handleUniTrack()
      })
    },
    onFlightSearch (date, index) {
      const { search, ifInternational } = this
      const originDestination = {
        ...search.originDestinations[index]
      }
      originDestination.flightDate = date
      search.originDestinations.splice(index, 1, originDestination)
      const originDestinations = ifInternational ? search.originDestinations : [originDestination]
      this.handleFlightSearchValidateBefore({
        ...search,
        originDestinations
      }, !ifInternational ? index : null)
    },
    onApproachSearch (flightInfo, index) {
      const { search, ifInternational } = this
      const { flightNo, depCode, arrCode, type, tripType } = flightInfo
      const originDestination = {
        ...search.originDestinations[index],
        depCode,
        arrCode,
        flightNo
      }
      if (flightNo) {
        originDestination.depType = 'airport'
        originDestination.arrType = 'airport'
      }
      // TODO:邻近航班支持国际票查询后再做修改
      // search.originDestinations.splice(index, 1, originDestination)
      const originDestinations = ifInternational ? search.originDestinations : [originDestination]
      this.handleFlightSearchFetch({
        ...search,
        originDestinations,
        tripType
      }, !ifInternational ? index : null, type)
    },
    onFlightSelect (index, data, product, currentType) {
      const hideItinerary = currentType === 'normalFlight' ? 'approachFlight' : 'normalFlight'
      if (data) {
        this.showItinerary[hideItinerary] = false
        this.selectedProducts.splice(index, 1, {
          ...data,
          passengers: this.passengerStr
        })
        this.selectedProductsDetail.splice(index, 1, product)
        let _isSaleInside = false
        this.selectedProductsDetail.forEach(product => {
          if (product && product.detail && Array.isArray(product.detail.services)) {
            product.detail.services.forEach(item => {
              if (item.supplier !== mainSettings.airline) {
                _isSaleInside = true
              }
            })
          }
        })
        this.isSaleInside = _isSaleInside
      } else {
        this.showItinerary[hideItinerary] = true
        this.selectedProducts.splice(index, 1, null)
        this.selectedProductsDetail.splice(index, 1, null)
      }
    },

    // 国际票往返重新选择一段即全部重新选择（暂时没有其他更优方式）
    onCancelAll () {
      this.handleFlightSearchFetch(this.search)
      // this.offers.map((offer, offerIndex) => {
      //   this.$refs[`flight-item-${offerIndex}`].forEach(item => {
      //     item.selectedProduct = null
      //     item.itinerarys.map(itinerary => {
      //       itinerary.isHide = false
      //       itinerary.cabins.forEach(cabin => {
      //         cabin.brands.forEach(brand => {
      //           brand.isHide = true
      //           // brand.products.forEach(product => {
      //           //   product.isHide = false
      //           // })
      //         })
      //       })
      //     })
      //   })
      // })
      // const list = []
      // const listDetail = []
      // this.offers.map(offer => {
      //   list.push(null)
      //   listDetail.push(null)
      // })
      // this.selectedProducts = list
      // this.selectedProductsDetail = listDetail
    },
    async onSubmit () {
      window.__MICRO_ROOT__?.api?.track?.('reserve_OTA_click')
      const { isSaleInside, appInfo, isJJC } = this
      const { originDestinations } = this.search
      const user = mainSettings.user?.get() || {}
      const hasAuth = user.userType !== 0 || user.authStatus === 4
      const isNeedAuth = isJJC && !hasAuth
      // const { isSaleInside, ifInternational, appInfo, search } = this
      // // 国际票暂不支持携带婴儿下单
      // if (ifInternational) {
      //   const ifInternationalHasInf = search.passenger?.INF > 0
      //   if (ifInternationalHasInf) {
      //     this.$message.error('国际航班暂不支持携带婴儿，请重新选择乘客后进行查询。')
      //     return false
      //   }
      // }
      // NOTE: ALL - 往返程航班时间规则校验
      if (originDestinations.length > 1) {
        const dateTo = moment(originDestinations[0]?.flightDate)?.valueOf()
        const dateBack = moment(originDestinations[1]?.flightDate)?.valueOf()
        if (dateBack < dateTo) {
          this.$message.error('往返程航班，去程时间不能大于返程时间！')
          return false
        }
      }
      if (isSaleInside) {
        // 互售航班提示
        const h = this.$createElement
        this.$info({
          title: '温馨提示',
          content: h('div', {}, [
            h('p', '尊敬的旅客：'),
            h('p', { style: {
              textIndent: '2em'
            } },
            !['8L'].includes(mainSettings.airline)
              ? `您选择的航班中包含非${appInfo.name}实际承运的航班，请您在出行前密切关注实际承运航空公司的航班动态信息。`
              : `您正在预订包含非${appInfo.name}承运的机票，后续如需办理值机选座、辐营购买等服务，请至实际承运航司官方渠道操作办理。`
            )
          ]),
          onOk: () => {
            this.submit()
          }
        })
      } else if (['8L'].includes(mainSettings.airline) && isNeedAuth) {
        // 8L - 军警残需要实名认证
        const params = {
          depCode: originDestinations[0].depCode,
          arrCode: originDestinations[0].arrCode,
          flightDate: originDestinations[0].flightDate
        }
        const href = document.location.href + '&' + queryString.stringify(params)
        this.$confirm({
          title: '温馨提示',
          content: `尊敬的旅客，根据${appInfo.name}相关规定，购买军/警残客票的账户须为实名认证账户，请您先完成实名认证，感谢您的理解。`,
          okText: '去实名认证',
          cancelText: '取消',
          onOk: () => {
            window.sessionStorage.setItem('redirect', href)
              mainSettings.router?.push({
                pathname: '/micro/user/authenticate',
                query: { type: 'auth' }
              })
          },
          onCancel: () => {
            this.submitting = false
            return false
          }
        })
      } else {
        await this.submit()
      }
    },
    async submit () {
      const cities = await flightCities()
      const { selectedProductsDetail, selectedProducts, ifInternational, shoppingRespId, enableUploadJjcCert, isJJC } = this
      // 是否包含跨天航班，要提示
      let plusDayNotice = ''
      const selecteds = selectedProductsDetail.map((product, i) => {
        return product.detail.services.map((service, idx) => {
          const benefits = service.benefit ? (service.benefit.benefits || []) : []
          const depCity = _.find(cities, { code: service.departureCode })
          const arrCity = _.find(cities, { code: service.arrivalCode })
          const time = moment(`${selectedProducts[i].departureDate} ${selectedProducts[i].departureTime}`)
          const flightSegmentCity = `${depCity.city}-${arrCity.city}航段`
          let mealText = ''
          let luggageText = ''
          let carryText = ''
          if (time) {
            const hour = time.hour()
            if (hour >= 0 && hour < 2) {
              plusDayNotice += `您购买的${depCity.city}-${arrCity.city}航班为零点后起飞，请于${time.subtract('h', 2).format('YYYY年MM月DD日 HH:mm')}前到达机场办理乘机手续，谢谢。`
            }
          }
          console.log('benefits >>>> ', JSON.parse(JSON.stringify(benefits)))
          if (Array.isArray(benefits) && benefits.length > 0) {
            const currentBenefits = benefits[0]
            if (currentBenefits.benefitDetails?.length > 0) {
              const meal = benefits[0]?.benefitDetails.find(item => item.code === 'MEAL' || item.code === 'FOOD_IN_THE_AIR') ?? {}
              mealText = meal.name ? `${meal.name}，` : ''
            }
            if (currentBenefits.languageBenefitDetails?.length > 0) {
              const adiltBenefits = currentBenefits.languageBenefitDetails.find(item => item.passengerType === 'ADULT') || {}
              const luggage = adiltBenefits.checkinBenefit || {}
              luggageText = `${parseInt(luggage.data?.replace(/[^0-9]+/g, '')) !== 0 ? `提供${luggage.name}，` : '不提供免费托运行李，'}`
              const carry = adiltBenefits.carryBenefit || {}
              const carryData = JSON.parse(carry.data)
              carryText = parseInt(carryData.q) > 0 ? `提供${carry.name}` : '不提供免费手提行李'
            } else {
              luggageText = '不提供免费托运行李，'
              carryText = '不提供免费手提行李'
            }
            return `${flightSegmentCity}${mealText}${luggageText}${carryText}`
          } else {
            return `${flightSegmentCity}无免费餐饮，不提供免费托运行李，不提供免费手提行李`
          }
        }).join('，')
      })

      const txt = `尊敬的旅客，您购买的${selecteds.join('；')}，继续购买请确认。`

      this.$confirm({
        title: '温馨提示',
        content (h) {
          return (
            <div style="text-indent: 2em">
              { txt }<br/>
              { plusDayNotice }
            </div>
          )
        },
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.submitting = true
          const params = {
            products: JSON.parse(this.products),
            allowUpload: isJJC && enableUploadJjcCert
          }
          // 国际票新增参数
          if (ifInternational) {
            params.ifInternational = ifInternational
            params.shoppingRespId = shoppingRespId
            // 国际票往返行程更新 offerItemId
            const groupOfferItemIdList = []
            params.products.forEach(item => {
              groupOfferItemIdList.push(item.offerItemIds[0].groupOfferItemIdList)
            })
            const offerItemId = _.intersection(groupOfferItemIdList[0], groupOfferItemIdList[1])[0]
            if (offerItemId && params.products.length > 1) {
              params.products.forEach(item => {
                item.offerItemIds[0].offerItemId = offerItemId
                delete item.offerItemIds[0].groupOfferItemIdList
              })
            }
            // const offerItemId = params.products.find(item => { return item.offerItemIds[0].groupOfferItemIdList?.length === 1 })?.offerItemIds[0].offerItemId
            // if (offerItemId && params.products.length > 1) {
            //   params.products.forEach(item => {
            //     item.offerItemIds[0].offerItemId = offerItemId
            //     delete item.offerItemIds[0].groupOfferItemIdList
            //   })
            // }
          }
          fetchProductChoose(params)
            .then(result => {
              if (result.shoppingCartId) {
                // NOTE: 国际票票价变化时需要重新查询、选购
                if (result.ifInternational && result.oldTotalAmount !== result.newTotalAmount) {
                  this.$error({
                    title: '温馨提示',
                    content: '您选择的航线价格已发生变动，请重新搜索查询。',
                    onOk: () => {
                      this.$router.go(0)
                    }
                  })
                  return false
                }
                Storage.setItem(`SHOPPINGCART_DATA`, result, 0.5 * 3600000)
                this.submitting = false
                this.$router.push({
                  path: '/flight/passenger'
                })
              } else {
                this.$error({
                  title: '温馨提示',
                  content: '预订异常，请重新下单',
                  onOk: () => {
                    this.$router.go(0)
                  }
                })
              }
            })
            .catch(err => {
              this.submitting = false
              this.$message.error(err.message || '网络异常，请稍后再试！')
            })
            // this.$refs.passengerForm.submit()
        },
        onCancel: () => {
          this.submitting = false
          return false
        }
      })
    },
    isMatchAirline (airlines) {
      const { originDestinations } = this.search

      if (originDestinations && originDestinations.length) {
        let match = false
        originDestinations.forEach(orgDst => {
          if (airlines.indexOf(`${orgDst.depCode} ${orgDst.arrCode}`) > -1) {
            match = true
          }
        })

        return match
      } else {
        return false
      }
    },
    handleUniTrack (error) {
      try {
        const { search = {}, track } = this
        const { startPostTime, endPostTime, startRenderTime, endRenderTime } = track
        const postTime = ((endPostTime - startPostTime) / 1000).toFixed(2)
        const renderTime = ((endRenderTime - (startRenderTime || startPostTime)) / 1000).toFixed(2)
        this.track.startRenderTime = null
        const isIntercept = window.localStorage.getItem('flight_is_intercept')
        if (isIntercept) {
          window.localStorage.removeItem('flight_is_intercept')
        }
        if (postTime < 0 || renderTime < 0) {
          return
        }
        const trackParams = {
          flight_org_code: search.originDestinations?.[0].depCode,
          flight_dst_code: search.originDestinations?.[0].arrCode,
          flight_search_inf_time: postTime,
          flight_search_inf_time_decimal: postTime,
          flight_is_intercept: isIntercept === 'true' ? '是' : '否',
          flight_search_page_loading_time: renderTime,
          flight_page_time_decimal: renderTime
        }
        if (error) {
          trackParams.inf_error_info = error.message
        }
        window.__MICRO_ROOT__?.api?.track?.('UNI_FlightSearch', trackParams)
      } catch (error) {
        console.log('error >>>> ', error.message)
      }
    },
    getTotalAmount (includeTax = true) {
      const { selectedProductsDetail, ifInternational } = this
      return _.sumBy(ifInternational ? (selectedProductsDetail.length ? [selectedProductsDetail?.[0]] : []) : selectedProductsDetail, item => {
        const service = item.detail?.services?.[0] ?? {}
        return includeTax ? (service.defaultFareIncludeTax) : service.defaultFare?.amount
      })
    },
    getTaxAmount () {
      const { selectedProductsDetail, ifInternational } = this
      return _.sumBy(ifInternational ? (selectedProductsDetail.length ? [selectedProductsDetail?.[0]] : []) : selectedProductsDetail, item => {
        const service = item.detail?.services?.[0] ?? {}
        return service.defaultTax
      })
    },
    turnToJDValidate (data) {
      const query = getFlightSearchParams(data)
      const keys = Object.keys(query)
      if (keys?.includes('CNN') || keys?.includes('INF')) {
        const { name, hotline } = this.appInfo
        const message = `预订${name}实际承运的国内、国际航班时，每名年满18周岁的成人最多可带3名未满5岁的儿童，含1名婴儿；携带5（含）至12岁（不含）以下儿童无数量限制。如同行的儿童为残疾儿童，则仅可携带一名残疾儿童出行，不能再携带其他儿童及婴儿同行，详情可联系${hotline}咨询。预订非${name}实际承运的国内、国际及联程段航班，每名年满18周岁的成人最多可携带2名儿童及1名婴儿。`
        this.$confirm({
          title: '温馨提示',
          content: message,
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            this.turnToJDAction(query)
          }
        })
      } else {
        this.turnToJDAction(query)
      }
    },
    turnToJDAction (query) {
      this.loading = true
      const defaultKey = 'e3Y6ICIyLjUuMCIsIG9zOiAid2ViIiwgczogMTk5LCBlOiAianMgbm90IGRvd25sb2FkIn0='
      // TODO: 避免首航临时调整影响，计划调整为 cms 配置
      const prefix = mainSettings.environment === 'production' ? 'new' : 'newuat'
      const url = 'https://' + prefix + '.jdair.net/jdair#/ticket/tripList'
      // 同盾blackBox获取相关  放在首页初始化时的相关代码
      var randd = new Date().getTime()
      var rralength = randd.toString().length
      var randdsub = randd.toString().substr(rralength - 2)
      randdsub = Math.floor(randdsub / 100) * 10
      window._fmOpt = {
        display: 'popup', // popup方式渲染验证码
        container: '.fm', // 验证码button渲染的目标DOM，自动展现方式下必需，详情见后文
        area: '.fm', // 对于custom模式，弹出窗口的加载容器，详情见后文
        partner: 'sdair',
        appName: 'tydl_pc',
        fmb: true,
        initialTime: new Date().getTime(),
        token: 'sdair' + '-' + new Date().getTime() + '-' + randdsub.toString(16).substr(2),
        env: 1,
        closeIcon: '1',
        closeMask: '1'
      }
      var fm = document.createElement('script'); fm.type = 'text/javascript'
      fm.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') +
      'static.tongdun.net/captcha/main/tdc.js?ver=1.0&t=' +
      (new Date().getTime() / 600000).toFixed(0)
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(fm, s)
      setTimeout(() => {
        query['blackBox'] = window._fmOpt?.getinfo?.()
        let timnum = 0
        if (!query['blackBox'] || query['blackBox'] === defaultKey) {
          let timeIn = setInterval(function () {
            timnum++
            if (window._fmOpt?.getinfo?.() && window._fmOpt?.getinfo?.() !== defaultKey) {
              query['blackBox'] = encodeURIComponent(window._fmOpt?.getinfo?.())
              clearInterval(timeIn)
              this.loading = false
              window.location.href = queryString.stringifyUrl({ url, query })
            } else if (timnum === 100) {
            // 限时5秒 5秒不管有没有结果都跳国际票
              query['blackBox'] = encodeURIComponent(window._fmOpt?.getinfo?.())
              clearInterval(timeIn)
              this.loading = false
              window.location.href = queryString.stringifyUrl({ url, query })
            }
          }, 100)
        } else {
          this.loading = false
          window.location.href = queryString.stringifyUrl({ url, query })
        }
      }, 500)
    }
  },
  components: {
    Flight,
    Approachs
  }
}
</script>
